import { render, staticRenderFns } from "./contractTypeManageList.vue?vue&type=template&id=5023ef00&scoped=true"
import script from "./contractTypeManageList.vue?vue&type=script&lang=js"
export * from "./contractTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./contractTypeManageList.vue?vue&type=style&index=0&id=5023ef00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023ef00",
  null
  
)

export default component.exports